import React from "react";

interface FooterProps {
  onPrivacyPolicyClick?: () => void;
  onContactUsClick?: () => void;
  onTermsClick?: () => void;
}

export function Footer({ onPrivacyPolicyClick, onContactUsClick, onTermsClick }: FooterProps) {
  return (
    <footer className="hidden sm:block border-t border-border-default/60 bg-surface-base">
      <div className="max-w-5xl mx-auto px-4 py-10 text-base text-text-secondary text-center space-y-4">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <span className="text-text-muted">© {new Date().getFullYear()} Snip Rush. All rights reserved.</span>
          <div className="flex flex-wrap items-center justify-center gap-4">
            {onPrivacyPolicyClick && (
              <button
                onClick={onPrivacyPolicyClick}
                className="text-text-secondary hover:text-accent-primary transition-colors underline decoration-dotted decoration-accent-primary/60"
              >
                Privacy Policy
              </button>
            )}
            {onContactUsClick && (
              <button
                onClick={onContactUsClick}
                className="text-text-secondary hover:text-accent-primary transition-colors underline decoration-dotted decoration-accent-primary/60"
              >
                Contact Us
              </button>
            )}
            {onTermsClick && (
              <button
                onClick={onTermsClick}
                className="text-text-secondary hover:text-accent-primary transition-colors underline decoration-dotted decoration-accent-primary/60"
              >
                Terms & Conditions
              </button>
            )}
          </div>
        </div>
        <p className="text-sm text-text-muted">
          Your content stays private. All processing happens in your browser.
        </p>
      </div>
    </footer>
  );
}

